var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import "./index.scss";
import React, { useRef } from "react";
import { SearchSuggestionCard } from "../SearchSuggestionCard";
import { useStandaloneSearchHelper } from "..";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper";
import { Lazy } from "swiper";
import "swiper/css";
import SliderArrows from "../../../components/sliderCore/SliderArrows";
SwiperCore.use([Navigation]);
export var SearchRow = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var title = props.title, _o = props.show, show = _o === void 0 ? 3 : _o, titleFontConfig = props.titleFontConfig, className = props.className, renderData = props.renderData, style = props.style, showClearButton = props.showClearButton, clearButtonLabel = props.clearButtonLabel, clearCb = props.clearCb, rest = __rest(props, ["title", "show", "titleFontConfig", "className", "renderData", "style", "showClearButton", "clearButtonLabel", "clearCb"]);
    var onItemClickHandler = useStandaloneSearchHelper().onItemClickHandler;
    var _p = (_c = (_b = (_a = props.moduleData) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.settings) === null || _c === void 0 ? void 0 : _c.columns, desktop = _p.desktop, mobile = _p.mobile, ott = _p.ott, tablet = _p.tablet;
    var showMonetizationBadge = (_f = (_e = (_d = props.moduleData) === null || _d === void 0 ? void 0 : _d.layout) === null || _e === void 0 ? void 0 : _e.settings) === null || _f === void 0 ? void 0 : _f.showMonetizationBadge;
    var layoutSettings = (_h = (_g = props.moduleData) === null || _g === void 0 ? void 0 : _g.layout) === null || _h === void 0 ? void 0 : _h.settings;
    var fontSetting = (_k = (_j = props.moduleData) === null || _j === void 0 ? void 0 : _j.layout) === null || _k === void 0 ? void 0 : _k.fontSetting;
    var prevNavRef = useRef(null);
    var nextNavRef = useRef(null);
    return (React.createElement("div", __assign({ className: "vl_search_page_row ".concat(className), style: style }, rest),
        React.createElement("div", { className: "vl_search_page_row_title" },
            React.createElement("h1", { style: __assign({}, titleFontConfig) }, title),
            React.createElement("span", { id: "slider-cta" },
                showClearButton ? (React.createElement("p", { role: "button", id: "clearButton", onClick: clearCb }, clearButtonLabel)) : null,
                React.createElement("div", { className: "tray-navigation-wrapper" },
                    React.createElement("div", { ref: prevNavRef },
                        React.createElement(SliderArrows, { to: "prev", onClick: function () { return console.log("last"); }, className: true, isArticlePage: false })),
                    React.createElement("div", { ref: nextNavRef },
                        React.createElement(SliderArrows, { to: "next", onClick: function () { return console.log("first"); }, className: true, isArticlePage: false }))))),
        React.createElement("div", { className: "vl_search_page_row_content" },
            React.createElement(Swiper, { spaceBetween: 10, className: "mySwiper", modules: [Lazy], navigation: {
                    prevEl: prevNavRef.current,
                    nextEl: nextNavRef.current,
                }, onInit: function (swiper) {
                    swiper.params.navigation.prevEl = prevNavRef.current;
                    swiper.params.navigation.nextEl = nextNavRef.current;
                    swiper.navigation.init();
                    swiper.navigation.update();
                }, breakpoints: {
                    650: {
                        slidesPerView: mobile !== null && mobile !== void 0 ? mobile : 1.3,
                        slidesPerGroup: 1,
                    },
                    768: {
                        slidesPerView: tablet !== null && tablet !== void 0 ? tablet : 2.7,
                        slidesPerGroup: 2,
                    },
                    1024: {
                        slidesPerView: desktop || 4.5,
                        slidesPerGroup: 3,
                    },
                } }, (_m = (_l = renderData === null || renderData === void 0 ? void 0 : renderData.search) === null || _l === void 0 ? void 0 : _l.records) === null || _m === void 0 ? void 0 : _m.map(function (node) { return (React.createElement(SwiperSlide, null,
                React.createElement(SearchSuggestionCard, { key: node.id, onClick: function () {
                        onItemClickHandler({ clickedNode: node, url: node.gist.permalink });
                    }, onKeyDown: function (e) {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            e.stopPropagation();
                            onItemClickHandler({ clickedNode: node, url: node.gist.permalink });
                        }
                    }, data: node, showMonetizationBadge: showMonetizationBadge, layoutSettings: layoutSettings, fontSetting: fontSetting }))); })))));
};
